// Axios
import axios from "src/lib/axios"

// --------------------------------------------|| COMMON - SERVICES || -------------------------------------------

const getTypeList = () => {
  return axios.get("/api/v1/common/getAllTypeGroup")
}
const getTypeById = id => {
  return axios.get("/api/v1/common/getAllTypeByGroupId", {
    params: {
      id: id
    }
  })
}

const getStatusList = () => {
  return axios.get("/api/v1/common/getAllStatusGroup")
}

const getStatusById = id => {
  return axios.get("/api/v1/common/getAllStatusByGroupId", {
    params: {
      id: id
    }
  })
}

const commonServices = { getTypeList, getTypeById, getStatusList, getStatusById }

export default commonServices
